import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=370147cf&scoped=true&"
import script from "./PaymentSummary.vue?vue&type=script&lang=ts&"
export * from "./PaymentSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&id=370147cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370147cf",
  null
  
)

export default component.exports